import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    CategoriesEMployeeHelpdesk: {},
    GetEmployeeTickets: {},
    GetEmpTicket: {},
    GetTicketArray: [],
    ReplyTicketData: {},
    UpdateReplyTicket: {},
    GetReplyTicketData: {},
    TicketData: {},
}

const employeehelpdeskConfigSlice = createSlice({
    name: 'employeehelpdeskConfigSlice',
    initialState,
    reducers: {
        saveCategoriesEmployeeHelpdesk: (state, action) => {
            return { ...state, CategoriesEMployeeHelpdesk: action?.payload }
        },
        saveGetEmployeeTickets: (state, action) => {
            return { ...state, GetEmployeeTickets: action?.payload }
        },
        saveGetEmpTicket: (state, action) => {
            return { ...state, GetEmpTicket: action?.payload }
        },
        saveReplyTicketData: (state, action) => {
            return { ...state, ReplyTicketData: action?.payload }
        },
        saveUpdateReplyTicketData: (state, action) => {
            return { ...state, UpdateReplyTicket: action?.payload }
        },
        saveGetReplyTicketData: (state, action) => {
            return { ...state, GetReplyTicketData: action?.payload }
        },
        saveGetTicketData: (state, action) => {
            return { ...state, TicketData: action?.payload }
        },
    }
})

export const { saveGetTicketData, saveUpdateReplyTicketData, saveReplyTicketData, saveCategoriesEmployeeHelpdesk, saveGetEmployeeTickets, saveGetEmpTicket, saveGetReplyTicketData } = employeehelpdeskConfigSlice.actions;
export default employeehelpdeskConfigSlice.reducer;